import * as React from 'react';
import type { GobiSectionBlockViewModel } from '../ViewModel/GobiSectionBlockViewModel.csharp';
import { GobiSection } from '~/Features/StudyPage/Campus/Components/GobiSection/GobiSection';
import type { GobiStoryProps } from '~/Features/StudyPage/Campus/Components/GobiStory/GobiStory';
import type { OverlayContainerProps } from '~/Features/StudyPage/Campus/Components/Overlay/WithOverlay';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';

export const GobiSectionBlock: React.FC<GobiSectionBlockViewModel> = props => {
    const { id, title, content, gobiStoryId, imageFallback, overlayTitle, overlayContent, translations } = props;

    const getOverlayProps = (): OverlayContainerProps<HtmlString> | undefined =>
        overlayTitle && overlayContent
            ? {
                  overlayLabel: overlayTitle,
                  content: overlayContent,
                  openLabel: translations.openOverlay,
                  closeLabel: translations.closeOverlay,
              }
            : undefined;

    const getGobiProps = (): GobiStoryProps | undefined =>
        gobiStoryId
            ? {
                  storyId: gobiStoryId,
                  openLabel: translations.openPlayer,
                  errorMessage: translations.failedToLoadVideo,
              }
            : undefined;

    return (
        <GobiSection
            id={id}
            title={title}
            content={content}
            overlay={getOverlayProps()}
            gobi={getGobiProps()}
            imageFallback={imageFallback}
        />
    );
};
